/*
 * Cart trust badge placement.
 *
 * The badge is rendered (server-side) inside `.drawer__footer`. The Onward
 * Checkout+ app injects its buttons into that footer at runtime — and often
 * LATE — which can leave the badge above them. To guarantee it stays BELOW
 * everything, we keep the badge as the LAST child of `.drawer__footer`.
 *
 * Reliability (handles late/async Onward loads):
 *   - place() is idempotent (no-op once the badge is already the last child), so
 *     it can never loop or thrash.
 *   - A document MutationObserver (rAF-debounced) re-runs place() whenever the
 *     DOM changes — catches Onward injecting/re-rendering anywhere, anytime.
 *   - A bounded poll (~12s after each cart interaction) is a belt-and-suspenders
 *     fallback in case a mutation is missed. It stops itself, so no permanent timer.
 */
(function () {
  if (window.__cartTrustBadgeInit) return;
  window.__cartTrustBadgeInit = true;

  function place() {
    var badges = document.querySelectorAll('[data-cart-trust-badge]');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      var footer = badge.closest('.drawer__footer');
      if (!footer) continue;
      if (footer.lastElementChild === badge) continue; // Already at the bottom.
      footer.appendChild(badge);
    }
  }

  var raf = false;
  function schedule() {
    if (raf) return;
    raf = true;
    requestAnimationFrame(function () {
      raf = false;
      place();
    });
  }

  // Bounded poll — catches a late Onward block even if a mutation is missed.
  var pollId = null;
  var pollUntil = 0;
  function poll() {
    pollUntil = Date.now() + 12000;
    place();
    if (pollId) return;
    pollId = setInterval(function () {
      place();
      if (Date.now() > pollUntil) {
        clearInterval(pollId);
        pollId = null;
      }
    }, 350);
  }

  function armObserver() {
    if (window.__ctbObs || !document.body) return;
    window.__ctbObs = new MutationObserver(schedule);
    window.__ctbObs.observe(document.body, { childList: true, subtree: true });
  }

  // Any click can open the drawer or change the cart; capture-phase catches them all.
  document.addEventListener('click', poll, true);
  document.addEventListener('DOMContentLoaded', function () {
    armObserver();
    poll();
  });
  window.addEventListener('pageshow', poll);

  armObserver();
  poll();
})();
